module.exports = __webpack_public_path__ + "img/img-2.f8cbf798.png";